import { application } from "./application";

import HwComboboxController from "@josefarias/hotwire_combobox"
application.register("hw-combobox", HwComboboxController)

import StickyController from "./sticky_controller";
application.register("sticky", StickyController);

import MulticityController from "./multicity_controller";
application.register("multicity", MulticityController);

import PasswordVisibility from "stimulus-password-visibility";
application.register("password-visibility", PasswordVisibility);

import CharacterCounter from "stimulus-character-counter";
application.register("character-counter", CharacterCounter);

import FloatingButtonsController from "./floating_buttons_controller";
application.register("floating-buttons", FloatingButtonsController);

import Dropdown from "stimulus-dropdown";
application.register("dropdown", Dropdown);

import Clipboard from "stimulus-clipboard";
application.register("clipboard", Clipboard);

import PreviewController from "./preview_controller";
application.register("preview", PreviewController);

import ShareController from "./share_controller";
application.register("share", ShareController);

import FlashController from "./flash_controller";
application.register("flash", FlashController);

import SearchController from "./search_controller";
application.register("search", SearchController);

import AutocompleteController from "./autocomplete_controller";
application.register("autocomplete", AutocompleteController);

import CountselectedController from "./countselected_controller";
application.register("countselected", CountselectedController);

import UncheckController from "./uncheck_controller";
application.register("uncheck", UncheckController);

import FilterdropController from "./filterdrop_controller";
application.register("filterdrop", FilterdropController);

import TabbedController from "./tabbed_controller";
application.register("tabbed", TabbedController);

import ValidemailController from "./validemail_controller";
application.register("validemail", ValidemailController);

import PopupController from "./popup_controller";
application.register("popup", PopupController);

import CouponController from "./coupon_controller";
application.register("coupon", CouponController);

import TrixController from "./trix_controller";
application.register("trix", TrixController);

import ArticleTocController from "./article_toc_controller"
application.register("article-toc", ArticleTocController)

import ReadingProgressController from "./reading_progress_controller"
application.register("reading-progress", ReadingProgressController)

import RevealController from "./reveal_controller";
application.register("reveal", RevealController);

import ToggleController from "./toggle_controller";
application.register("toggle", ToggleController);

import TextToggleController from "./text_toggle_controller";
application.register("text-toggle", TextToggleController);

import AdTrackerController from "./ad_tracker_controller";
application.register("ad-tracker", AdTrackerController);

import HideController from "./hide_controller";
application.register("hide", HideController);

import UnsavedController from "./unsaved_controller";
application.register("unsaved", UnsavedController);

import FeedbackController from "./feedback_controller";
application.register("feedback", FeedbackController);

import CookieController from "./cookie_controller";
application.register("cookie", CookieController);

import JobpreviewController from "./jobpreview_controller";
application.register("jobpreview", JobpreviewController);

import CvuploadController from "./cvupload_controller";
application.register("cvupload", CvuploadController);

import DisableFormController from "./disable_form_controller";
application.register("disable_form", DisableFormController);

import DialogController from './dialog_controller';
application.register('dialog', DialogController);

import RelatedModalController from "./related_modal_controller";
application.register("related-modal", RelatedModalController);
